const LogoutIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <mask
        id="mask0_1465_26576"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1465_26576)">
        <path
          d="M12.7708 13.5625C12.6181 13.3819 12.5417 13.1769 12.5417 12.9475C12.5417 12.7186 12.6181 12.5278 12.7708 12.375L14.3125 10.8333H8.33333C8.09722 10.8333 7.89944 10.7533 7.74 10.5933C7.58 10.4339 7.5 10.2361 7.5 10C7.5 9.76389 7.58 9.56583 7.74 9.40583C7.89944 9.24639 8.09722 9.16667 8.33333 9.16667H14.3125L12.7708 7.625C12.6042 7.45833 12.5208 7.26056 12.5208 7.03167C12.5208 6.80222 12.6042 6.60417 12.7708 6.4375C12.9236 6.27083 13.1147 6.1875 13.3442 6.1875C13.5731 6.1875 13.7639 6.26389 13.9167 6.41667L16.9167 9.41667C17 9.5 17.0592 9.59028 17.0942 9.6875C17.1286 9.78472 17.1458 9.88889 17.1458 10C17.1458 10.1111 17.1286 10.2153 17.0942 10.3125C17.0592 10.4097 17 10.5 16.9167 10.5833L13.9167 13.5833C13.7361 13.7639 13.5383 13.8436 13.3233 13.8225C13.1078 13.8019 12.9236 13.7153 12.7708 13.5625ZM4.16667 17.5C3.70833 17.5 3.31583 17.3369 2.98917 17.0108C2.66306 16.6842 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66306 3.31583 2.98917 2.98917C3.31583 2.66306 3.70833 2.5 4.16667 2.5H9.16667C9.40278 2.5 9.60083 2.57972 9.76083 2.73917C9.92028 2.89917 10 3.09722 10 3.33333C10 3.56944 9.92028 3.76722 9.76083 3.92667C9.60083 4.08667 9.40278 4.16667 9.16667 4.16667H4.16667V15.8333H9.16667C9.40278 15.8333 9.60083 15.9133 9.76083 16.0733C9.92028 16.2328 10 16.4306 10 16.6667C10 16.9028 9.92028 17.1006 9.76083 17.26C9.60083 17.42 9.40278 17.5 9.16667 17.5H4.16667Z"
          fill="#969696"
        />
      </g>
    </svg>
  );
};
export default LogoutIcon;
